import Div from "components/primitives/Div";
import Typography from "components/Typography";
import useOrganisation from "contexts/OrganisationContext/useOrganisation";
import { useUserContext } from "hooks";

function SettingsProfile() {
  const [{ profile }] = useUserContext();
  const organisation = useOrganisation();

  return (
    <Div sx={{ overflow: "hidden", width: "100%" }}>
      <Typography
        data-sensitive
        variant="TextS"
        fontWeight="fontWeightMedium"
        noWrap
        sx={{ color: "white", lineHeight: "16px" }}
      >
        {profile?.name}
      </Typography>
      <Typography data-sensitive variant="TextXS" noWrap sx={{ color: "white", lineHeight: "16px" }}>
        {organisation?.name}
      </Typography>
    </Div>
  );
}

export default SettingsProfile;
